import { PathOptions } from "leaflet";
import { unidades_conservacao_ambiental } from "./unidades_conservacao_ambiental";
import { aves_migratorias_areas_de_concentracao } from "./aves_migratorias_areas_de_concentracao";
import { rios } from "./rios";
import { canais } from "./canais";
import { adutoras } from "./adutoras";
import { rodovias_federais } from "./rodovias_federais";
import { rodovias_estaduais } from "./rodovias_estaduais";
import { ferrovias } from "./ferrovias";
import { transnordestina_trecho_ferroviario_valec_pe } from "./transnordestina_trecho_ferroviario_valec_pe";
import { cavernas_pe } from "./cavernas_pe";
import { assentamentos_publicos } from "./assentamentos_publicos";
import { area_quilombola } from "./area_quilombola";
import { terras_indigenas_homologadas } from "./terras_indigenas_homologadas";
import { areas_prioritarias_conservacao_caatinga } from "./areas_prioritarias_conservacao_caatinga";
import { areas_prioritarias_conservacao_mata_atlantica } from "./areas_prioritarias_conservacao_mata_atlantica";
import { estado_pe } from "./estado_pe";
import { municipios_pe } from "./municipios_pe";
import { regioes_imediatas_pe } from "./regioes_imediatas_pe";
import { apl_pe_observatorio } from "./apl_pe_observatorio";
import { municipios_pe_adepe } from "./municipios_pe_adepe";
import { estados_bra } from "./estados_bra";
import { sitios_arqueologicos } from "./sitios_arqueologicos";
import { corpos_dagua } from "./corpos_dagua";

// ArcGIS Layers (Pending GeoServer Migration)
import { areas_suscetiveis_desertificacao } from "./areas_suscetiveis_desertificacao";
import { zoneamento_agroecologico_pernambuco } from "./zoneamento_agroecologico_pernambuco";
import { portos } from "./portos";
import { gasoduto_transporte_pe } from "./gasoduto_transporte_pe";
import { gasoduto_distribuicao_pe } from "./gasoduto_distribuicao_pe";
import { hidrovias_fluxo_de_cabotagem } from "./hidrovias_fluxo_de_cabotagem";
import { pe_aeroportos } from "./pe_aeroportos";
import { polos_empresariais } from "./polos_empresariais";
import { linhas_de_trem_do_grande_recife } from "./linhas_de_trem_do_grande_recife";
import { estacoes_de_trem_do_grande_recife } from "./estacoes_de_trem_do_grande_recife";

// Infraestrutura de Energia - Planejado
import { linhas_de_transmissao_expansao_planejada } from "./linhas_de_transmissao_expansao_planejada";
import { subestacoes_expansao_planejada } from "./subestacoes_expansao_planejada";
import { eol_expansao_planejada } from "./eol_expansao_planejada";
import { ufv_expansao_planejada } from "./ufv_expansao_planejada";

// Infraestrutura de Energia - Em operação
import { linhas_de_transmissao_base_existente } from "./linhas_de_transmissao_base_existente";
import { subestacoes_base_existente } from "./subestacoes_base_existente";
import { neoenergia_pe_ssdat } from "./neoenergia_pe_ssdat";
import { lts_neoenergia } from "./lts_neoenergia";
import { neoenergia_pe_unseat } from "./neoenergia_pe_unseat";
import { neoenergia_pe_uncrat } from "./neoenergia_pe_uncrat";
import { neoenergia_pe_unreat } from "./neoenergia_pe_unreat";
import { neoenergia_pe_untrat } from "./neoenergia_pe_untrat";
import { neoenergia_pe_conj_dgc } from "./neoenergia_pe_conj_dgc";
import { eol_base_existente } from "./eol_base_existente";
import { ufv_base_existente } from "./ufv_base_existente";
import { uhe_base_existente } from "./uhe_base_existente";
import { pch_base_existente } from "./pch_base_existente";
import { cgh_base_existente } from "./cgh_base_existente";
import { ute_biomassa_base_existente } from "./ute_biomassa_base_existente";
import { ute_fossil_base_existente } from "./ute_fossil_base_existente";
import { boundary_30km } from "./boundary_30km";
import { boundary_100km } from "./boundary_100km";

// Serviços Geológicos do Brasil (SGB/CPRM) — só a camada de pontos precisa
// de estilo no cliente; litoestratigrafia_1m e suscet_inundacao usam o SLD
// oficial do SGB no GeoServer.
import { sgb_ocorrencias_recursos_minerais } from "./sgb_ocorrencias_recursos_minerais";

type StyleFunction = (feature: any) => PathOptions;

export const layerStyles: Record<string, StyleFunction> = {
  unidades_conservacao_ambiental,
  aves_migratorias_areas_de_concentracao,
  rios,
  canais,
  adutoras,
  rodovias_federais,
  rodovias_estaduais,
  ferrovias,
  "TRANSNORDESTINA-TRECHO-FERROVIÁRIO-VALEC-PE":
    transnordestina_trecho_ferroviario_valec_pe,
  cavernas_pe,
  assentamentos_publicos,
  area_quilombola,
  terras_indigenas_homologadas,
  areas_prioritarias_conservacao_caatinga,
  areas_prioritarias_conservacao_mata_atlantica,
  estado_pe,
  municipios_pe,
  regioes_imediatas_pe,
  apl_pe_observatorio,
  municipios_pe_adepe,
  estados_bra,
  sitios_arqueologicos,
  corpos_dagua,
  // ArcGIS Layers
  areas_suscetiveis_desertificacao,
  zoneamento_agroecologico_pernambuco,
  portos,
  gasoduto_transporte_pe,
  gasoduto_distribuicao_pe,
  hidrovias_fluxo_de_cabotagem,
  pe_aeroportos,
  polos_empresariais,
  "linhas-de-trem-do-grande-recife": linhas_de_trem_do_grande_recife,
  "estacoes-de-trem-do-grande-recife": estacoes_de_trem_do_grande_recife,
  // Infraestrutura de Energia - Planejado
  linhas_de_transmissao_expansao_planejada,
  subestacoes_expansao_planejada,
  eol_expansao_planejada,
  ufv_expansao_planejada,
  // Infraestrutura de Energia - Em operação
  linhas_de_transmissao_base_existente,
  subestacoes_base_existente,
  neoenergia_pe_ssdat,
  "LTS-neoenergia": lts_neoenergia,
  neoenergia_pe_unseat,
  neoenergia_pe_uncrat,
  neoenergia_pe_unreat,
  neoenergia_pe_untrat,
  neoenergia_pe_conj_dgc,
  boundary_30km,
  boundary_100km,
  eol_base_existente,
  ufv_base_existente,
  uhe_base_existente,
  pch_base_existente,
  cgh_base_existente,
  ute_biomassa_base_existente,
  ute_fossil_base_existente,
  // Serviços Geológicos do Brasil
  sgb_ocorrencias_recursos_minerais,
};

export const getLayerStyle = (layerName: string): StyleFunction | undefined => {
  return layerStyles[layerName];
};

// Export style variations utilities
export { hasStyleVariations, getStyleVariations } from "./variations";
export type { StyleVariation } from "./variations";
